import SEOMeta from "../../components/base/SEOMeta";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import AdSlot from "../../components/base/AdSlot";
import HeroSection from "./components/HeroSection";
import FeaturedQuizzes from "./components/FeaturedQuizzes";
import CategorySection from "./components/CategorySection";
import TrendingSection from "./components/TrendingSection";

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const homeJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "QuizVibe",
    "url": SITE_URL,
    "description": "Fun viral personality quizzes for kids and teens — Disney, Roblox, Toca Boca, Anime and more.",
    "inLanguage": "en",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": `${SITE_URL}/categories?q={search_term_string}`
      },
      "query-input": "required name=search_term_string"
    }
  },
  {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    "name": "QuizVibe – Fun Personality Quizzes for Kids & Teens",
    "description": "Take the most viral personality quizzes on QuizVibe! Discover your Disney princess, Toca Boca dream house, Roblox character, and more. New quizzes every week!",
    "url": SITE_URL,
    "inLanguage": "en",
    "publisher": {
      "@type": "Organization",
      "name": "QuizVibe",
      "url": SITE_URL
    }
  }
];

export default function Home() {
  return (
    <div className="min-h-screen" style={{ fontFamily: "'Nunito', sans-serif" }}>
      <SEOMeta
        title="QuizVibe – Fun Personality Quizzes for Kids & Teens | Disney, Roblox & More"
        description="Take the most viral personality quizzes on QuizVibe! Discover your Disney princess, Toca Boca dream house, Roblox character, and more. New quizzes every week for kids and teens!"
        keywords="personality quiz, kids quiz, teens quiz, Disney quiz, Roblox quiz, Toca Boca quiz, anime quiz, fun quizzes"
        canonicalPath="/"
        ogImage="https://public.readdy.ai/ai/img_res/84bdbcf74aa3d5ba90a2e73da18b5c1d.jpg"
        jsonLd={homeJsonLd}
      />
      <Navbar />
      <main>
        <HeroSection />

        {/* ── Ad: Leaderboard below hero (desktop) / mobile banner ── */}
        <div className="w-full bg-white border-y border-gray-100 py-2">
          <div className="max-w-7xl mx-auto px-4 flex items-center justify-center">
            {/* Desktop leaderboard */}
            <div className="hidden md:block">
              <AdSlot size="leaderboard" />
            </div>
            {/* Mobile banner */}
            <div className="md:hidden w-full flex justify-center">
              <AdSlot size="mobile-banner" />
            </div>
          </div>
        </div>

        <FeaturedQuizzes />

        {/* ── Ad: In-content responsive banner ── */}
        <div className="w-full py-4 bg-[#FAFAFA]">
          <div className="max-w-4xl mx-auto px-4 flex justify-center">
            <AdSlot size="responsive" className="w-full" />
          </div>
        </div>

        <CategorySection />

        <TrendingSection />

        {/* ── Ad: Leaderboard above footer ── */}
        <div className="w-full bg-white border-t border-gray-100 py-4">
          <div className="max-w-7xl mx-auto px-4 flex items-center justify-center">
            <div className="hidden md:block">
              <AdSlot size="leaderboard" />
            </div>
            <div className="md:hidden w-full flex justify-center">
              <AdSlot size="mobile-banner" />
            </div>
          </div>
        </div>
      </main>
      <Footer />

      {/* ── Ad: Sticky bottom banner (mobile only) ── */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-200 flex items-center justify-center py-1 shadow-lg">
        <AdSlot size="sticky-mobile" />
      </div>
    </div>
  );
}
